import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import { ConferenceResultsUI } from './ui';

export class ConferenceResults extends PureComponent {
    static displayName = 'ConferenceResultsContainer';

    static propTypes = {
        enabled: PropTypes.bool.isRequired,
        hasMoreResults: PropTypes.bool.isRequired,
        highlightedResult: PropTypes.objectOf(PropTypes.any),
        highlightResult: PropTypes.func.isRequired,
        indexElement: PropTypes.func.isRequired,
        loading: PropTypes.bool.isRequired,
        loadingMoreResults: PropTypes.bool.isRequired,
        loadMoreResults: PropTypes.func.isRequired,
        onClickResult: PropTypes.func.isRequired,
        results: PropTypes.arrayOf(PropTypes.any).isRequired
    };

    static defaultProps = {
        highlightedResult: null
    };

    render() {
        const {
            enabled,
            hasMoreResults,
            highlightedResult,
            highlightResult,
            indexElement,
            loading,
            loadingMoreResults,
            loadMoreResults,
            onClickResult,
            results
        } = this.props;
        return (
            <ConferenceResultsUI
                enabled={enabled}
                hasMoreResults={hasMoreResults}
                highlightedResult={highlightedResult}
                highlightResult={highlightResult}
                indexElement={indexElement}
                loading={loading}
                loadingMoreResults={loadingMoreResults}
                loadMoreResults={loadMoreResults}
                onClickResult={onClickResult}
                results={results}
            />
        );
    }
}

export const ConferenceResultsContainer = compose()(ConferenceResults);
